import { Component, inject, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services';
import { SharedModule } from '@shared/shared.module';
import { SynDropdownComponent } from '@synergy-design-system/angular/components/dropdown';
import { pageUrls } from 'src/app/configuration/pages';
import { assetUrl } from '@shared/utils';
import appPackage from '../../../../../../package.json';

/**
 * Represents the UserInfoComponent.
 */
@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  imports: [SharedModule],
})
export class UserInfoComponent {
  appName: string = `${appPackage.title}`;
  appVersion: string = `v${appPackage.version}`;
  isAboutOpen = false;

  private router = inject(Router);
  userInforDropdown = viewChild.required<SynDropdownComponent>('dropdown');

  constructor(protected authService: AuthService) {}

  logout() {
    this.authService.logout();
  }

  goToProfile() {
    this.userInforDropdown().open = false;
    this.router.navigate([pageUrls.profile]);
  }

  openAbout() {
    const dropdown = this.userInforDropdown();
    dropdown.open = false;
    this.isAboutOpen = true;
  }

  changePassword() {
    this.userInforDropdown().open = false;
    this.router.navigate([pageUrls.profile], { queryParams: { tab: 'password' } });
  }

  getUserName() {
    const session = this.authService.session();
    const name = session ? session.name : undefined;
    if (!name) return '';
    const characters = name.split(' ');
    const initials = characters.map((c: string) => c.charAt(0)).join('');
    return initials.toUpperCase();
  }

  /** Display URL for the user's avatar, or empty string when none is set. */
  avatarUrl(): string {
    return assetUrl(this.authService.session()?.avatar);
  }
}
